export default {
  // 页面标题
  title: "余额分析",

  // 表单相关
  chainPlaceholder: "请选择主链",
  addressPlaceholder: "请输入地址（最多不超过50条）",
  reset: "重置",
  query: "查询",

  // 统计信息
  totalAccountBalance: "公链代币总余额：",
  totalUsdtBalance: "usdt代币总余额：",

  // 表格列标题
  serialNumber: "序号",
  blockchain: "公链",
  address: "地址",
  accountBalance: "公链代币余额(可用余额)",
  usdtBalance: "USDT代币余额",
  updateTime: "更新时间",

  // 空数据
  noData: "暂无数据",

  // 下载相关
  downloadDetails: "下载数据明细",
  downloadFileName: "余额数据",

  // Loading 文本
  loading: "拼命加载中",

  // 验证和错误消息
  pleaseSelectChain: "请选择链",
  pleaseEnterAddress: "请输入地址",
  batchQueryLimit: "批量查询最多可查询50个以内的同一公链地址",

  // 新手引导
  guideStep1: "输入地址查询余额，支持批量（50以内）地址余额查询",
};
